import { useState } from "react";
import { Link } from "react-router-dom";
import { FaChevronDown, FaPhone, FaEnvelope, FaMapMarkerAlt, FaLinkedinIn, FaInstagram, FaFacebookF, FaBars, FaTimes } from "react-icons/fa";
import "../Style/Navbar.css";
import ascentLogo from "../assets/ascentlogo.png";

function Navbar() {
  const [activeGroup, setActiveTabGroup] = useState("iso-core");
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [isMobileDropdownOpen, setIsMobileDropdownOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileOpen(!isMobileOpen);
    if (isMobileOpen) {
      setIsMobileDropdownOpen(false); // Reset dropdown when closing menu
    }
  };

  // High-Density Data Matrix mapping all standard certificates dynamically
  const dropdownData = {
    "iso-core": {
      heading: "ISO Management Systems",
      teaser: "International core operational management frameworks commonly deployed across organizations.",
      links: [
        { label: "ISO 9001:2015 Quality Management System (QMS)", id: "iso-9001" },
        { label: "ISO 14001:2015 Environmental Management System (EMS)", id: "iso-14001" },
        { label: "ISO 45001:2018 Occupational Health & Safety Management System", id: "iso-45001" },
        { label: "ISO 50001:2018 Energy Management System", id: "iso-50001" },
        { label: "ISO 55001:2014 Asset Management System", id: "iso-55001" },
        { label: "ISO 41001:2018 Facility Management System", id: "iso-41001" }
      ]
    },
    "food-lab": {
      heading: "Food Safety, Healthcare & IT Standards",
      teaser: "Targeted structural security controls handling nutrition logistics, medical devices, and IT hardware.",
      links: [
        { label: "ISO 22000:2018 Food Safety Management System", id: "iso-22000" },
        { label: "HACCP Certification", id: "haccp" },
        { label: "FSSC 22000 Food Safety Certification", id: "fssc-22000" },
        { label: "GMP (Good Manufacturing Practices)", id: "gmp" },
        { label: "GHP (Good Hygiene Practices)", id: "ghp" },
        { label: "BRCGS Food Safety Certification", id: "brcgs" },
        { label: "MSC Chain of Custody (Sustainable Seafood)", id: "msc-coc" },
        { label: "Halal Certification", id: "halal" },
        { label: "ISO 13485:2016 Medical Devices QMS", id: "iso-13485" },
        { label: "ISO 15189 Medical Laboratories Requirements", id: "iso-15189" },
        { label: "NABH Consultancy Services", id: "nabh-consultancy" },
        { label: "ISO 20000-1:2018 IT Service Management", id: "iso-20000-1" }
      ]
    },
    "infosec": {
      heading: "InfoSec & Infrastructure Security",
      teaser: "Advanced information shielding parameters protecting critical corporate and healthcare networks.",
      links: [
        { label: "ISO/IEC 27001:2022 Information Security Management (ISMS)", id: "iso-27001" },
        { label: "ISO 28000:2022 Supply Chain Security Management", id: "iso-28000" }
      ]
    },
    "regulatory": {
      heading: "Corporate Governance, Risk & Operations",
      teaser: "Enterprise guidelines maintaining legal compliance, continuity, risk management, and responsibility.",
      links: [
        { label: "ISO 22301:2019 Business Continuity Management System", id: "iso-22301" },
        { label: "ISO 37001:2016 Anti-Bribery Management System", id: "iso-37001" },
        { label: "ISO 31000 Risk Management Guidelines", id: "iso-31000" },
        { label: "ISO 21001:2018 Educational Organization Management", id: "iso-21001" },
        { label: "ISO 39001:2012 Road Traffic Safety Management", id: "iso-39001" },
        { label: "ISO 26000 Social Responsibility Guidance", id: "iso-26000" },
        { label: "ISO 20121:2024 Sustainable Event Management", id: "iso-20121" },
        { label: "ISO 10002:2018 Customer Complaint Management", id: "iso-10002" },
        { label: "ISO 10001:2018 Customer Satisfaction Codes of Conduct", id: "iso-10001" }
      ]
    }
  };

  return (
    <nav className="navbar-wrapper base-fade-in">
      {/* Top Utility Contact & Social Bar */}
      <div className="navbar-top-bar">
        <div className="top-bar-container">
          <div className="top-bar-item">
            <FaMapMarkerAlt className="top-bar-icon" />
            <span>Minhaa, Karankaa Magu, Malé, Republic of Maldives</span>
          </div>
          <div className="top-bar-right">
            <a href="tel:+919867180395" className="top-bar-item">
              <FaPhone className="top-bar-icon" />
              <span>+91 9867180395</span>
            </a>
            <a href="mailto:info@ascentinspecta.com" className="top-bar-item">
              <FaEnvelope className="top-bar-icon" />
              <span>info@ascentinspecta.com</span>
            </a>
            {/* Social Media Integration */}
            <div className="top-bar-socials">
              <a 
                href="https://in.linkedin.com/in/satyajeet-sharma-20970115?trk=public_post_feed-actor-name" 
                target="_blank" 
                rel="noopener noreferrer" 
                aria-label="LinkedIn"
                className="top-social-icon"
              >
                <FaLinkedinIn />
              </a>
              <a 
                href="https://www.instagram.com/maldives.ascent/profilecard/?igsh=MWVrMWw4MXhlM2h3N" 
                target="_blank" 
                rel="noopener noreferrer" 
                aria-label="Instagram"
                className="top-social-icon"
              >
                <FaInstagram />
              </a>
              <a 
                href="https://www.facebook.com/AscentMaldives" 
                target="_blank" 
                rel="noopener noreferrer" 
                aria-label="Facebook"
                className="top-social-icon"
              >
                <FaFacebookF />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Main Navbar Bar */}
      <div className="navbar">
        {/* Logo Container */}
        <div className="Logo">
          <Link to="/">
            <img src={ascentLogo} alt="Ascent Inspecta Logo" className="navbar-logo" />
          </Link>
        </div>

        {/* Mobile Hamburger Button */}
        <button className="menu-toggle" onClick={toggleMobileMenu} aria-label="Toggle Navigation">
          {isMobileOpen ? <FaTimes /> : <FaBars />}
        </button>

        {/* Navigation Links */}
        <ul className={`nav-links ${isMobileOpen ? "mobile-open" : ""}`}>
          <li><Link to="/" onClick={() => setIsMobileOpen(false)}>Home</Link></li>
          <li><Link to="/about" onClick={() => setIsMobileOpen(false)}>About</Link></li>
          
          {/* Services Dropdown Parent */}
          <li className="dropdown-parent">
            <span 
              className="dropdown-trigger-link"
              onClick={() => setIsMobileDropdownOpen(!isMobileDropdownOpen)}
            >
              Services <FaChevronDown className={`nav-chevron ${isMobileDropdownOpen ? "rotate" : ""}`} />
            </span>
            
            <div className={`navbar-mega-dropdown ${isMobileDropdownOpen ? "mobile-show" : ""}`}>
              {/* Left Control Column Tab Rail */}
              <div className="dropdown-sidebar-nav">
                <div className="dropdown-header-block">
                  <span className="pulse-dot-indicator"></span>
                  <span>COMPLIANCE ENGINE</span>
                </div>
                <button 
                  className={`tab-toggle-btn ${activeGroup === "iso-core" ? "active" : ""}`}
                  onMouseEnter={() => setActiveTabGroup("iso-core")}
                  onClick={() => setActiveTabGroup("iso-core")}
                >
                  Management Systems
                </button>
                <button 
                  className={`tab-toggle-btn ${activeGroup === "food-lab" ? "active" : ""}`}
                  onMouseEnter={() => setActiveTabGroup("food-lab")}
                  onClick={() => setActiveTabGroup("food-lab")}
                >
                  Food, Health &amp; IT
                </button>
                <button 
                  className={`tab-toggle-btn ${activeGroup === "infosec" ? "active" : ""}`}
                  onMouseEnter={() => setActiveTabGroup("infosec")}
                  onClick={() => setActiveTabGroup("infosec")}
                >
                  Security &amp; Logistics
                </button>
                <button 
                  className={`tab-toggle-btn ${activeGroup === "regulatory" ? "active" : ""}`}
                  onMouseEnter={() => setActiveTabGroup("regulatory")}
                  onClick={() => setActiveTabGroup("regulatory")}
                >
                  Governance &amp; Operations
                </button>
              </div>

              {/* Right Display Pane mapping children routes dynamically */}
              <div className="dropdown-content-pane">
                <div className="pane-title-wrap">
                  <h4 className="pane-heading-styled">{dropdownData[activeGroup].heading}</h4>
                  <p>{dropdownData[activeGroup].teaser}</p>
                </div>
                <div className="dropdown-links-grid">
                  {/* Independent Hub Core Navigation Sections */}
                  <Link to="/certifications" className="dropdown-matrix-link full-span-link" onClick={() => setIsMobileOpen(false)}>
                    <span>[View All Services Matrix]</span>
                    <span className="mini-arrow">&rarr;</span>
                  </Link>

                  {/* Individual Target Routes Pointing Directly to the Sub-Details View */}
                  {dropdownData[activeGroup].links.map((target) => (
                    <Link 
                      key={target.id} 
                      to={`/certifications/${target.id}`} 
                      className="dropdown-matrix-link child-link-node"
                      onClick={() => setIsMobileOpen(false)}
                    >
                      <span>{target.label}</span>
                      <span className="mini-arrow">&rarr;</span>
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </li>

          <li><Link to="/certifications" onClick={() => setIsMobileOpen(false)}>Certifications</Link></li>
          <li><Link to="/blog" onClick={() => setIsMobileOpen(false)}>Blog</Link></li>
          <li><Link to="/contact" onClick={() => setIsMobileOpen(false)}>Contact</Link></li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;